export const PATHS = {
  INDEX: '/',

  // onboarding
  ONBOARDING_ADD_PLATE_NUMBER: '/onboarding/add-plate-number',
  ONBOARDING_VERIFY_VEHICLE_REGISTRATION:
    '/onboarding/verify-vehicle-registration',
  ONBOARDING_VERIFY_VEHICLE_REGISTRATION_CAMERA:
    '/onboarding/verify-vehicle-registration/camera',
  ONBOARDING_VERIFY_VEHICLE_REGISTRATION_PREVIEW:
    '/onboarding/verify-vehicle-registration/preview',

  ONBOARDING_VERIFY_DRIVER_LICENSE: '/onboarding/verify-driver-license',
  ONBOARDING_VERIFY_DRIVER_LICENSE_CAMERA:
    '/onboarding/verify-driver-license/camera',
  ONBOARDING_VERIFY_DRIVER_LICENSE_PREVIEW:
    '/onboarding/verify-driver-license/preview',

  ONBOARDING_PROCESS: '/onboarding/process',
  ONBOARDING_REVIEW: '/onboarding/review',

  ONBOARDING_VERIFIED_SUCCESS: '/onboarding/verified-success',
  ONBOARDING_VERIFIED_DATA_CHECK: '/onboarding/verified-data-check',

  // AUTH
  AUTH_LINE: '/auth/line',
} as const;
